var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpcoming(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 4.5C12.1088 4.5 12.9425 4.89697 14.0238 5.88003L14.1611 6.00512C14.9896 6.75952 15.4668 7 16.5 7C17.0194 7 17.5664 6.7265 18.1465 6.14645C18.4614 5.83146 19 6.05455 19 6.5C19 9.41667 17.8125 11 15.5 11C14.9156 11 14.5278 10.8537 13.965 10.5084L13.831 10.4258C13.3169 10.1092 13.0212 10 12.5 10C11.413 10 10.4694 10.4832 9.64558 11.4822L11.9794 19.358C12.0579 19.6227 11.9068 19.9009 11.6421 19.9794C11.3773 20.0578 11.0991 19.9068 11.0206 19.642L7.02061 6.14204C6.96491 5.95404 7.02491 5.75925 7.15918 5.63402C7.97443 4.87402 9.0965 4.5 10.5 4.5ZM10.5 5.5C9.47271 5.5 8.66922 5.72697 8.0723 6.17255L9.31421 10.364C10.2292 9.4616 11.2963 9 12.5 9C13.2392 9 13.6978 9.16942 14.3553 9.57423L14.4879 9.65604C14.9077 9.91351 15.1369 10 15.5 10C16.9108 10 17.71 9.24285 17.9342 7.58248C17.4668 7.85844 16.9884 8 16.5 8C15.1759 8 14.4834 7.65105 13.4878 6.74451L13.3512 6.61997C12.4388 5.79053 11.8287 5.5 10.5 5.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcoming);
export default __webpack_public_path__ + "static/media/upcoming.d75e392c327b385ce5279d12b58ce89c.svg";
export { ForwardRef as ReactComponent };